import React from 'react'

import {
  ControlGroup,
  ControlGroupItem,
  ControlGroupHolder,
  Grid,
  Spinner,
} from '@plurall/elo-beta'

import { useMainMenu } from './hooks'
import styles from './MainMenu.module.scss'

const MainMenu: React.FC = () => {
  const {
    isFetching,
    getMenuData,
    isCurrentPath,
    onClick,
    isTabletBreakpoint,
    isDesktopBreakpoint,
  } = useMainMenu()

  const isMobileBreakpoint = !isTabletBreakpoint && !isDesktopBreakpoint
  if (isMobileBreakpoint) {
    return null
  }
  if (isFetching) {
    return (
      <div className={styles.loading} data-test-id='loading-spinner'>
        <Spinner />
      </div>
    )
  }

  return (
    <Grid desktop={3}>
      <ControlGroup noCard>
        <ControlGroupHolder>
          {getMenuData.map(({ link_url: url, name, slug }, index) => (
            <div
              key={`menu-item-${index + 1}`}
              className={isCurrentPath(url) ? styles['menu-item'] : ''}
            >
              <ControlGroupItem
                key={`menu-group-item-${index + 1}`}
                dataTestId={`${slug}-account-menu-item`}
                onClick={() => onClick(url)}
              >
                {name}
              </ControlGroupItem>
            </div>
          ))}
        </ControlGroupHolder>
      </ControlGroup>
    </Grid>
  )
}

export default MainMenu
